import { Button } from '@mui/material';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useSelector } from 'react-redux';

export const DialogButton = ({ children, onClick, color = "#4285f4", focusColor = "primary.main", focusKey }) => {
    const { ref, focused } = useFocusable({
        focusKey: focusKey,
        onEnterPress: onClick,
    });

    const { theme } = useSelector((state) => state.application);

    const buttonTheme = {
        primaryButton: theme?.cta?.primary?.bgColor ?? color,
        primaryButtonText: theme?.cta?.primary?.color ?? color,
        secondaryButton: theme?.cta?.secondary?.bgColor ?? color,
        secondaryButtonText: theme?.cta?.secondary?.color ?? color,
    }

    return (
        <Button
            ref={ref}
            onClick={onClick}
            sx={{
                backgroundColor: focused ? buttonTheme.primaryButton : buttonTheme.secondaryButton,
                color: focused ? buttonTheme.primaryButtonText : buttonTheme.secondaryButtonText,
                border: focused ? '2px solid #007FFF' : '2px solid transparent',
                '&:hover': {
                    backgroundColor: buttonTheme.primaryButton,
                }
            }}
        >
            {children}
        </Button>
    );
};